// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"76b12056","238":"b88e7586","256":"598e3af3","302":"be8632b2","323":"e17d669d","372":"614b3d4b","453":"e9e7ec89","524":"4eaa16f0","624":"a6c48fcc","632":"99c50e51","663":"0272500d","678":"49f74544"}[chunkId] + ".chunk.js";
};